"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_USER_AGENT = exports.IS_BROWSER = exports.DEFAULT_BASE_URLS = void 0;
exports.DEFAULT_BASE_URLS = {
    chzzkBaseUrl: "https://api.chzzk.naver.com",
    gameBaseUrl: "https://comm-api.game.naver.com/nng_main"
};
exports.IS_BROWSER = typeof window !== "undefined";
exports.DEFAULT_USER_AGENT = "Mozilla/5.0 (Windows NT 6.3; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/37.0.2049.0 Safari/537.36";
